var storefrontApp = angular.module("storefrontApp");
storefrontApp.controller("personalizedDesignsController", [
    "$scope",
    "cartService",
    "modalService",
    "loaderService",
    "accountService",
    "storefrontApp.mainContext",
    function (
        $scope,
        cartService,
        modalService,
        loaderService,
        accountService,
        storefrontAppMainContext
    ) {
        // Initialize scope variables
        $scope.activeTab = "resize";
        $scope.validationMessage = "";
        // Product data
        $scope.product = {
            name: window.products[0].name,
            brand: window.products[0].brand,
            definitionName: window.products[0].definitionName,
            imageUrl: (function () {
                var def = window.products[0].definitionName.toLowerCase();
                var brand = window.products[0].catalogId
                    .replace(/\s+/g, "_")
                    .toLowerCase();
                var itemIdParts = window.products[0].id.split("-");
                var itemId =
                    itemIdParts.length > 1 ? itemIdParts[1] : itemIdParts[0];
                return (
                    "https://img2.embroiderydesigns.com/" +
                    def +
                    "/xlarge/" +
                    brand +
                    "/" +
                    itemId +
                    ".webp"
                );
            })(),
            fta: window.products[0].fileTypes.split(",").map(function (x) {
                return x.trim().toUpperCase();
            }),
            variantDimensions: window.products[0].variantDimensions.split("|"),
        };

        // Resize object
        $scope.resize = {
            PDWidth: "",
            PDHeight: "",
            unit: "inches",
            PDIsProportionalHeight: false,
            PDIsCap: false,
            PDOrigItemId: "",
            PDOrigCatalog: "",
            PDOrigDefinitionName: "",
            PDOrderStatus: "",
            PDType: "",
            PDName: "",
        };

        // Price object
        $scope.price = {
            regular: 0,
            circle: 0,
        };
        $scope.circleDiscount = window.__env.personalizeCircleDiscount;
        $scope.capResizePrice = window.__env.personalizeCapResizePrice;

        // Button state variables
        $scope.buttonText = "ADD TO CART";
        $scope.buttonStyle = "";

        // Membership variables
        $scope.isCircleMember = false;
        $scope.isCircleMemberActive = false;
        $scope.membership = null;
        $scope.customer = null;

        // Tab management
        $scope.setActiveTab = function (tab) {
            $scope.activeTab = tab;
        };

        // Get club membership info
        function GetClubMembershipInfo() {
            if ($scope.customer && $scope.customer.contactId) {
                accountService
                    .getCustomerMembershipDetails($scope.customer.contactId)
                    .then(function (response) {
                        if (response && response.data) {
                            $scope.membership = response.data;
                            $scope.isCircleMember = true;
                            $scope.isCircleMemberActive =
                                $scope.membership.isActive;
                        } else {
                            $scope.isCircleMember = false;
                        }
                    })
                    .catch(function (error) {
                        console.error(
                            "Error fetching membership details:",
                            error
                        );
                        $scope.isCircleMember = false;
                    });
            } else {
                $scope.isCircleMember = false;
            }
        }

        // Debounced dimension change handler
        $scope.onDimensionChange = function () {
            validateDimensions();
            updatePricing();
        };

        // Unit change handler
        $scope.onUnitChange = function () {
            loaderService.show();
            $scope.resize.PDWidth = "";
            $scope.resize.PDHeight = "";
            $scope.resize.PDIsProportionalHeight = false;
            $scope.resize.PDIsCap = false;
            validateDimensions();
            updatePricing();
            loaderService.hide();
        };

        // Proportional height checkbox handler
        $scope.onProportionalChange = function () {
            loaderService.show();
            if ($scope.resize.PDIsProportionalHeight) {
                // If proportional height is checked, uncheck cap size
                $scope.resize.PDIsCap = false;
                // Clear height field
                $scope.resize.PDHeight = "";
                // Only clear width if it contains "Cap Optimized Size", preserve numerical values
                if ($scope.resize.PDWidth === "Cap Optimized Size") {
                    $scope.resize.PDWidth = "";
                }
            }
            validateDimensions();
            updatePricing();
            loaderService.hide();
        };

        // Cap size checkbox handler
        $scope.onCapSizeChange = function () {
            loaderService.show();
            if ($scope.resize.PDIsCap) {
                // If cap size is checked, uncheck proportional height
                $scope.resize.PDIsProportionalHeight = false;
                $scope.resize.PDWidth = "Cap Optimized Size";
                $scope.resize.PDHeight = "Cap Optimized Size";
            } else {
                // If cap size is unchecked, clear width and height
                $scope.resize.PDWidth = "";
                $scope.resize.PDHeight = "";
            }
            validateDimensions();
            updatePricing();
            loaderService.hide();
        };

        // Validation function
        function validateDimensions() {
            $scope.validationMessage = "";

            // Skip validation if Cap Size is selected
            if ($scope.resize.PDIsCap) {
                return true;
            }

            // If no options are selected and no dimensions entered, don't show validation errors
            var hasValidDimensions =
                ($scope.resize.PDWidth &&
                    $scope.resize.PDWidth !== "" &&
                    parseFloat($scope.resize.PDWidth) > 0) ||
                ($scope.resize.PDHeight &&
                    $scope.resize.PDHeight !== "" &&
                    parseFloat($scope.resize.PDHeight) > 0);
            var hasOptionsSelected =
                $scope.resize.PDIsProportionalHeight || $scope.resize.PDIsCap;

            if (!hasValidDimensions && !hasOptionsSelected) {
                return true; // No validation errors when nothing is selected/entered
            }

            // Convert dimensions to inches for validation
            var widthInInches = convertToInches(
                $scope.resize.PDWidth,
                $scope.resize.unit
            );
            var heightInInches = convertToInches(
                $scope.resize.PDHeight,
                $scope.resize.unit
            );

            // Get validation limits in the selected unit
            var minWidth = convertFromInches(1, $scope.resize.unit);
            var maxWidth = convertFromInches(12, $scope.resize.unit);
            var maxHeight = convertFromInches(16, $scope.resize.unit);

            // Width validation (in inches) - only if width is provided
            if (
                $scope.resize.PDWidth &&
                $scope.resize.PDWidth !== "" &&
                (widthInInches < 1 || widthInInches > 12)
            ) {
                $scope.validationMessage =
                    "Width must be between " +
                    minWidth +
                    "-" +
                    maxWidth +
                    " " +
                    $scope.resize.unit +
                    ".";
                return false;
            }

            // Height validation (only if not proportional and not cap size and height is provided)
            if (
                !$scope.resize.PDIsProportionalHeight &&
                !$scope.resize.PDIsCap &&
                $scope.resize.PDHeight &&
                $scope.resize.PDHeight !== ""
            ) {
                if (heightInInches > 16) {
                    $scope.validationMessage =
                        "Height must be less than " +
                        maxHeight +
                        " " +
                        $scope.resize.unit +
                        ".";
                    return false;
                }
            }

            // Check if dimensions match existing variant dimensions
            var userWidthRounded = Math.round(widthInInches * 100) / 100;
            var userHeightRounded = Math.round(heightInInches * 100) / 100;

            // For fonts, only check height if provided
            if ($scope.product.definitionName.toLowerCase() === "font") {
                if (heightInInches > 0) {
                    for (
                        var i = 0;
                        i < $scope.product.variantDimensions.length;
                        i++
                    ) {
                        var variantDim = $scope.product.variantDimensions[i];
                        if (variantDim && variantDim.trim() !== "") {
                            var dimensions = variantDim.split(",");
                            if (dimensions.length === 2) {
                                var variantWidth = parseFloat(dimensions[0]);
                                var variantHeight = parseFloat(dimensions[1]);

                                // Round variant dimensions to 2 decimal places
                                var variantWidthRounded =
                                    Math.round(variantWidth * 100) / 100;
                                var variantHeightRounded =
                                    Math.round(variantHeight * 100) / 100;

                                // For fonts, check if user height matches either variant width or height
                                if (
                                    userHeightRounded === variantWidthRounded ||
                                    userHeightRounded === variantHeightRounded
                                ) {
                                    $scope.validationMessage =
                                        "Size already exists.";
                                    return false;
                                }
                            }
                        }
                    }
                }
            } else {
                // For non-font products, check both width and height
                if (widthInInches > 0 && heightInInches > 0) {
                    for (
                        var i = 0;
                        i < $scope.product.variantDimensions.length;
                        i++
                    ) {
                        var variantDim = $scope.product.variantDimensions[i];
                        if (variantDim && variantDim.trim() !== "") {
                            var dimensions = variantDim.split(",");
                            if (dimensions.length === 2) {
                                var variantWidth = parseFloat(dimensions[0]);
                                var variantHeight = parseFloat(dimensions[1]);

                                // Round variant dimensions to 2 decimal places
                                var variantWidthRounded =
                                    Math.round(variantWidth * 100) / 100;
                                var variantHeightRounded =
                                    Math.round(variantHeight * 100) / 100;

                                // Check if dimensions match (considering both orientations)
                                if (
                                    (userWidthRounded === variantWidthRounded &&
                                        userHeightRounded ===
                                            variantHeightRounded) ||
                                    (userWidthRounded ===
                                        variantHeightRounded &&
                                        userHeightRounded ===
                                            variantWidthRounded)
                                ) {
                                    $scope.validationMessage =
                                        "Size already exists.";
                                    return false;
                                }
                            }
                        }
                    }
                }
            }

            return true;
        }

        // Update pricing based on dimensions
        function updatePricing() {
            var width = $scope.resize.PDWidth;
            var height = $scope.resize.PDHeight;
            var hasValidDimensions =
                (width && width !== "" && parseFloat(width) > 0) ||
                (height && height !== "" && parseFloat(height) > 0);
            var hasOptionsSelected =
                $scope.resize.PDIsProportionalHeight || $scope.resize.PDIsCap;

            if (!hasValidDimensions && !hasOptionsSelected) {
                $scope.price.regular = 0;
                $scope.price.circle = 0;
                return;
            }

            // Don't call service if form is not valid
            if (!$scope.isFormValid()) {
                $scope.price.regular = 0;
                $scope.price.circle = 0;
                return;
            }
            // Set scope.resize values from the modal
            $scope.resize.PDOrigItemId = window.products[0].id;
            $scope.resize.PDOrigCatalog = window.products[0].catalogId;
            $scope.resize.PDOrigDefinitionName =
                window.products[0].definitionName;
            $scope.resize.PDType = "resize";
            $scope.resize.PDName = $scope.product.name + " - Custom Size";

            // Convert dimensions to inches
            var widthInInches = convertToInches(
                $scope.resize.PDWidth,
                $scope.resize.unit
            );
            var heightInInches = convertToInches(
                $scope.resize.PDHeight,
                $scope.resize.unit
            );

            // Create a copy of resize object with converted values for the API call
            var resizeForApi = angular.copy($scope.resize);
            resizeForApi.PDWidth = widthInInches.toFixed(2);
            resizeForApi.PDHeight = heightInInches.toFixed(2);

            // Call the service to fetch personalized resize price
            cartService
                .fetchPersonalizedResizePrice(resizeForApi)
                .then(function (response) {
                    if (response && response.data) {
                        $scope.price.regular = parseFloat(response.data || 0);
                        $scope.price.circle = parseFloat(
                            (
                                response.data *
                                (1 - $scope.circleDiscount / 100)
                            ).toFixed(2)
                        );
                    } else {
                        // Fallback to default pricing if service fails
                        $scope.price.regular = parseFloat(
                            $scope.capResizePrice || 0
                        );
                        $scope.price.circle = parseFloat(
                            (
                                $scope.capResizePrice *
                                (1 - $scope.circleDiscount / 100)
                            ).toFixed(2)
                        );
                    }
                })
                .catch(function (error) {
                    console.error(
                        "Error fetching personalized resize price:",
                        error
                    );
                    $scope.price.regular = parseFloat(
                        $scope.capResizePrice || 0
                    );
                    $scope.price.circle = parseFloat(
                        (
                            $scope.capResizePrice *
                            (1 - $scope.circleDiscount / 100)
                        ).toFixed(2)
                    );
                });
        }

        // Form validation
        $scope.isFormValid = function () {
            if ($scope.validationMessage) {
                return false;
            }

            // If Cap Size is selected, form is always valid
            if ($scope.resize.PDIsCap) {
                return true;
            }

            // Convert dimensions to inches for validation
            var widthInInches = convertToInches(
                $scope.resize.PDWidth,
                $scope.resize.unit
            );
            var heightInInches = convertToInches(
                $scope.resize.PDHeight,
                $scope.resize.unit
            );

            // For font products, only height validation is needed
            if ($scope.product.definitionName.toLowerCase() === "font") {
                return (
                    !isNaN(heightInInches) &&
                    heightInInches > 0 &&
                    heightInInches <= 16
                );
            }

            // If Proportional Height is selected, only width needs to be valid
            if ($scope.resize.PDIsProportionalHeight) {
                return widthInInches >= 1 && widthInInches <= 12;
            }

            // For manual dimensions, both width and height need to be valid
            // Check if width and height are provided and valid
            if (
                isNaN(widthInInches) ||
                widthInInches < 1 ||
                widthInInches > 12
            ) {
                return false;
            }

            if (
                isNaN(heightInInches) ||
                heightInInches <= 0 ||
                heightInInches > 16
            ) {
                return false;
            }

            return true;
        };

        // Convert dimensions to inches
        function convertToInches(value, unit) {
            if (!value || isNaN(parseFloat(value))) {
                return 0;
            }

            var numValue = parseFloat(value);
            var result;

            switch (unit) {
                case "inches":
                    result = numValue;
                    break;
                case "cm":
                    result = numValue / 2.54; // 1 inch = 2.54 cm
                    break;
                case "mm":
                    result = numValue / 25.4; // 1 inch = 25.4 mm
                    break;
                default:
                    result = numValue; // Default to inches
                    break;
            }

            // Round to two decimal places
            return Math.round(result * 100) / 100;
        }

        // Convert inches to the specified unit
        function convertFromInches(valueInInches, unit) {
            if (!valueInInches || isNaN(parseFloat(valueInInches))) {
                return 0;
            }

            var numValue = parseFloat(valueInInches);
            var result;

            switch (unit) {
                case "inches":
                    result = numValue;
                    break;
                case "cm":
                    result = numValue * 2.54; // 1 inch = 2.54 cm
                    break;
                case "mm":
                    result = numValue * 25.4; // 1 inch = 25.4 mm
                    break;
                default:
                    result = numValue; // Default to inches
                    break;
            }

            // Round to two decimal places
            return Math.round(result * 100) / 100;
        }

        // Add to cart functionality
        $scope.addToCart = function () {
            // If button text is "PROCEED TO CHECKOUT", redirect to cart page
            if ($scope.buttonText === "PROCEED TO CHECKOUT") {
                window.location.href = "/cart";
                return;
            }

            loaderService.show();

            // Validate the form first
            if (!$scope.isFormValid()) {
                loaderService.hide();
                return;
            }

            // Convert dimensions to inches before sending to server
            var widthInInches = convertToInches(
                $scope.resize.PDWidth,
                $scope.resize.unit
            );
            var heightInInches = convertToInches(
                $scope.resize.PDHeight,
                $scope.resize.unit
            );

            // Build the resize object with converted values for the API call
            var resizeForApi = angular.copy($scope.resize);
            resizeForApi.PDWidth = widthInInches.toFixed(2);
            resizeForApi.PDHeight = heightInInches.toFixed(2);
            resizeForApi.PDOrigItemId = window.products[0].id;
            resizeForApi.PDOrigCatalog = window.products[0].catalogId;
            resizeForApi.PDOrigDefinitionName =
                window.products[0].definitionName;
            resizeForApi.PDType = "resize";
            resizeForApi.PDName = $scope.product.name + " - Custom Size";

            // Call the addPersonalizedDesignToCart service
            cartService
                .addPersonalizedDesignToCart(resizeForApi)
                .then(function (response) {
                    loaderService.hide();
                    if (
                        response &&
                        response.data &&
                        response.data.itemAdded === true
                    ) {
                        // Update button text and style
                        $scope.buttonText = "PROCEED TO CHECKOUT";
                        $scope.buttonStyle = "checkout-style";
                    }
                })
                .catch(function (error) {
                    loaderService.hide();
                    console.error(
                        "Error adding personalized design to cart:",
                        error
                    );
                });
        };

        // Clear validation message function
        $scope.clearValidationMessage = function () {
            $scope.validationMessage = "";
        };

        // Modal toggle function (existing)
        $scope.togglePersonalizedDesignsModal = function (status) {
            $scope.toggleModal("personalized-designs", status);

            // Calculate optimal height when modal opens
            if (status) {
                setTimeout(function () {
                    if ($scope.calculateOptimalModalHeight) {
                        $scope.calculateOptimalModalHeight();
                    }
                }, 200); // Delay to ensure modal is fully rendered
            }
        };

        $scope.toggleModal = function (key, state) {
            if (state) {
                modalService.open(key);
            } else {
                modalService.close(key);
            }
        };

        // Watch for customer changes
        $scope.$watch(
            function () {
                return storefrontAppMainContext.customer;
            },
            function (newCustomer) {
                if (newCustomer) {
                    $scope.customer = newCustomer;
                    GetClubMembershipInfo();
                }
            }
        );

        // Initialize on controller load
        $scope.$on("$viewContentLoaded", function () {
            // Initialize with default values - no preselection
            $scope.resize.PDWidth = "";
            $scope.resize.PDHeight = "";
            $scope.resize.unit = "inches";
            $scope.resize.PDIsProportionalHeight = false;
            $scope.resize.PDIsCap = false;

            // Initialize prices to 0
            $scope.price.regular = 0.0;
            $scope.price.circle = 0.0;

            // Initialize customer from main context
            $scope.customer = storefrontAppMainContext.customer;
            if ($scope.customer) {
                GetClubMembershipInfo();
            }

            // Set up dynamic modal height calculation
            $scope.calculateOptimalModalHeight = function () {
                // Wait for DOM to be ready
                setTimeout(function () {
                    var modalBody = document.querySelector(
                        ".personalized-designs-modal-body"
                    );
                    var modalContent = document.querySelector(".modal-content");
                    var checkboxGroup =
                        document.querySelector(".checkbox-group");

                    if (modalBody && modalContent && checkboxGroup) {
                        // Get the position of the last checkbox relative to the modal content
                        var checkboxGroupRect =
                            checkboxGroup.getBoundingClientRect();
                        var modalContentRect =
                            modalContent.getBoundingClientRect();

                        // Calculate the distance from top of modal content to bottom of checkbox group
                        var contentTop = modalContentRect.top;
                        var checkboxBottom = checkboxGroupRect.bottom;
                        var distanceFromTop = checkboxBottom - contentTop;

                        // Add padding (40px) after the checkbox group
                        var optimalHeight = distanceFromTop + 40;

                        // Get header and tabs height
                        var header = document.querySelector(".modal-header");
                        var tabs = document.querySelector(".modal-tabs");
                        var headerHeight = header ? header.offsetHeight : 0;
                        var tabsHeight = tabs ? tabs.offsetHeight : 0;

                        // Calculate total modal height
                        var totalHeight =
                            headerHeight + tabsHeight + optimalHeight;

                        // Apply constraints for different screen sizes
                        var maxHeight;
                        var windowHeight = window.innerHeight;

                        if (windowHeight < 900) {
                            // Laptop screens - keep original working height
                            maxHeight = windowHeight * 0.95;
                        } else if (windowHeight < 1100) {
                            // Medium monitors
                            maxHeight = windowHeight * 0.9;
                        } else if (windowHeight < 1300) {
                            // Large monitors
                            maxHeight = windowHeight * 0.85;
                        } else {
                            // Very large monitors
                            maxHeight = windowHeight * 0.8;
                        }

                        // Use the smaller of calculated height or max height
                        var finalHeight = Math.min(totalHeight, maxHeight);

                        // Apply the height to modal content
                        modalContent.style.height =
                            finalHeight - headerHeight - tabsHeight + "px";
                        modalContent.style.maxHeight =
                            finalHeight - headerHeight - tabsHeight + "px";

                        // Update modal body max-height
                        modalBody.style.maxHeight = finalHeight + "px";

                        // Force a reflow to ensure the height is applied
                        modalBody.offsetHeight;
                    }
                }, 100); // Small delay to ensure DOM is ready
            };

            // Calculate height when modal opens
            $scope.$watch("activeTab", function () {
                if ($scope.activeTab) {
                    $scope.calculateOptimalModalHeight();
                }
            });

            // Recalculate on window resize
            window.addEventListener("resize", function () {
                if (
                    document.querySelector(".personalized-designs-modal-body")
                ) {
                    $scope.calculateOptimalModalHeight();
                }
            });

            // Listen for modal open events
            $scope.$on("modal:opened", function (event, modalId) {
                if (modalId === "personalized-designs") {
                    setTimeout(function () {
                        $scope.calculateOptimalModalHeight();
                    }, 100);
                }
            });
        });
    },
]);
